
import React from 'react';
import { Link } from 'react-router-dom';

const AccessDeniedFooter: React.FC = () => {
  return (
    <>
      <div className="text-sm text-center text-gray-500">
        Already have an account? {" "}
        <Link to="/login" className="text-primary hover:underline">
          Sign in
        </Link>
      </div>
      <div className="text-sm text-center text-gray-500">
        <Link to="/" className="text-primary hover:underline">
          Back to home
        </Link>
      </div>
    </>
  );
};

export default AccessDeniedFooter;
